import BaseComponent from 'scripts/BaseComponent.js';
import Accordion from 'scripts/Accordion.js';

export default class SubmenuLinksAndImageBlock extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      link: '.js-link',
      container: '.js-container',
    };

    this.dom = {
      $component: component,
      $containers: this.$getAll(this.refs.container),
    };

    this.state = {
      accordion: null,
    };

    this.mount();
    this.init();
  }

  mount() {
    super.mount();
  }

  init() {
    const { dom, state } = this;
    this.setClickWithElement(dom.$containers, this.clickHandler);
    state.accordion = new Accordion(dom.$component);
  }

  clickHandler(element) {
    const link = element.querySelector(this.refs.link).href;
    window.location.href = link;
  }
}
